// removed by extract-text-webpack-plugin
module.exports = {"Button":"src-components----button-module---Button---3qeZK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/button.module.scss
// module id = 71
// module chunks = 35783957827783 114276838955818 142807904292071 184470312924441